// extracted by mini-css-extract-plugin
export default {"SelectInput":"select_SelectInput__jYAel"};